export const trimToFiveDecimals = (number) => {
  const stringNumber = number.toString();
  const [integerPart, decimalPart] = stringNumber.split(".");

  if (decimalPart) {
    return parseFloat(`${integerPart}.${decimalPart.slice(0, 5)}`);
  }
  return parseFloat(stringNumber);
};
